import { render, staticRenderFns } from "./SaveIndicator.vue?vue&type=template&id=0df892bb"
import script from "./SaveIndicator.vue?vue&type=script&lang=js"
export * from "./SaveIndicator.vue?vue&type=script&lang=js"
import style0 from "./SaveIndicator.vue?vue&type=style&index=0&id=0df892bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports